import { useEffect, useState } from 'react';

type FetchStatus = 'idle' | 'fetching' | 'uninitialised';

export default function useFetchEveryThirty(
  lastTimestamp: number | null,
  callback: () => void
): FetchStatus {
  const [fetchStatus, setFetchStatus] = useState<FetchStatus>('uninitialised');
  const thirtyMinutes = 30000 * 60;
  useEffect(() => {
    const lastUpdated =
      lastTimestamp === null || lastTimestamp < 0
        ? null
        : Date.now() - lastTimestamp;
    if (
      lastUpdated !== null &&
      lastUpdated < thirtyMinutes &&
      (fetchStatus === 'fetching' || fetchStatus === 'uninitialised')
    ) {
      setFetchStatus('idle');
      if (lastUpdated < thirtyMinutes) console.log('NOOP');
    } else if (
      (lastUpdated === null || lastUpdated > thirtyMinutes) &&
      fetchStatus === 'uninitialised'
    ) {
      callback();
      setFetchStatus('fetching');
    }
  }, [lastTimestamp, fetchStatus, callback, thirtyMinutes]);

  return fetchStatus;
}
